import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import { getBaseAtelier } from "../../utilities/defaultObjects"
import { ATELIER_ETAT_TRAVAUX_EN_COURS } from "../../utilities/Addons"
import {
	postAtelier,
	postAtelierReset,
} from "../../store/actions/atelierActions"
import { getBaseAtelierLigne } from "./AtelierLigneV2"
import { useHistory } from "react-router-dom"
import CustomModal from "../basics/interface/CustomModal"
import { generalStyles as gs } from "../styles/styles"

const AtelierModalCreeFicheMaster = ({ onClose, visible }) => {
	const { masterVehicules } = useSelector((state) => state.masterReducer)
	const { masterEntite } = useSelector((state) => state.masterReducer)
	const { listeAtelierModeles } = useSelector(
		(state) => state.atelierModeleInfo,
	)
	const { atelierInfo } = useSelector((state) => state)
	const dispatch = useDispatch()
	const history = useHistory()
	const [state, setState] = useState({
		vehiculeId: 0,
		partieId: 0,
		modeleId: 0,
		partieList: [],
	})
	const updateState = (key, value) => {
		let newState = { ...state, [key]: value }
		if (key === "vehiculeId") {
			if (value > 0) {
				newState.partieList = [
					...masterVehicules.find((v) => v.id === value)
						.propre_vehicule.parties,
				]
			} else newState.partieList = []
		}
		setState(newState)
	}
	const creeFicheMaster = () => {
		let newFicheMaster = getBaseAtelier()
		let newFicheMasterAls = []
		let newFicheMasterComs = []
		newFicheMaster.svp = true
		newFicheMaster.vehicule = state.vehiculeId
		newFicheMaster.entite = masterEntite.id
		newFicheMaster.etat = ATELIER_ETAT_TRAVAUX_EN_COURS
		newFicheMaster.adresse = masterEntite.adresses[0].id
		if (state.partieId > 0) newFicheMaster.partie = state.partieId
		if (state.modeleId > 0) {
			let modele = listeAtelierModeles.find((m) => m.id === state.modeleId)
			newFicheMasterAls = modele.atelierLigneModele.map((al) => ({
				...getBaseAtelierLigne(),
				...al,
				id: null,
				atelier: null,
				modele: state.modeleId,
			}))
			newFicheMasterComs = modele.atelierCommentaireModele.map((ac) => ({
				...ac,
				id: null,
				atelier: null,
				modele: state.modeleId,
			}))
		}
		dispatch(
			postAtelier(
				JSON.stringify({
					atelier: newFicheMaster,
					atelierLignes: newFicheMasterAls,
					atelierCommentaires: newFicheMasterComs,
				}),
			),
		).then((res) => {
			history.push(`/atelier/fiche/${res.atelier.id}`)
			onClose()
			dispatch(postAtelierReset())
		})
	}

	const svpModeles = listeAtelierModeles.filter((mod) => mod.svp)
	const { saving, saved } = atelierInfo.postAtelier
	const busy = saving || saved

	if (!visible) return null

	return (
		<CustomModal
			title={`Nouvelle fiche ${masterEntite.label || "Master"}`}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={[
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: onClose,
					disabled: busy,
				},
				{
					title: saving ? (
						<FontAwesomeIcon icon={faSync} spin />
					) : saved ? (
						<FontAwesomeIcon icon={faCheck} />
					) : (
						"Créer la fiche"
					),
					styleName: "primary",
					onClick: creeFicheMaster,
					disabled: busy || state.vehiculeId === 0,
				},
			]}
		>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>Véhicule</label>
					<select
						style={gs.input}
						value={state.vehiculeId}
						onChange={(e) =>
							updateState("vehiculeId", parseInt(e.target.value))
						}
					>
						<option value={0}>-</option>
						{masterVehicules.map((veh) => (
							<option key={`${veh.id}_veh`} value={veh.id}>
								{`${veh.marque} ${veh.modele}`}
							</option>
						))}
					</select>
				</div>

				{state.partieList.length > 0 && (
					<div style={gs.fieldRow}>
						<label style={gs.label}>Partie</label>
						<select
							style={gs.input}
							value={state.partieId}
							onChange={(e) =>
								updateState("partieId", parseInt(e.target.value))
							}
						>
							<option value={0}>-</option>
							{state.partieList.map((part) => (
								<option key={`${part.id}_part`} value={part.id}>
									{part.label}
								</option>
							))}
						</select>
					</div>
				)}

				{svpModeles.length > 0 && (
					<div style={gs.fieldRow}>
						<label style={gs.label}>Modèle</label>
						<select
							style={gs.input}
							value={state.modeleId}
							onChange={(e) =>
								updateState("modeleId", parseInt(e.target.value))
							}
						>
							<option value={0}>-</option>
							{svpModeles.map((mod) => (
								<option key={`${mod.id}_mod`} value={mod.id}>
									{mod.nom}
								</option>
							))}
						</select>
					</div>
				)}
			</div>
		</CustomModal>
	)
}

export default AtelierModalCreeFicheMaster
